/**
 모바일 앱 연동 관련 유틸리티
 @packageDocumentation
 */
import * as webUtils from '../web-utils'

declare const webkit: any

/**
 * 네이티브 App 함수를 실행한다.
 * @param fnName
 * @param data
 */
export const callNative = (fnName: string, data: any) => {
  try {
    if (webUtils.isIOsRequest()) {
      webkit.messageHandlers[fnName].postMessage(data)
    } else {
      // @ts-ignore
      window.android[fnName](JSON.stringify(data))
    }
  } catch (e) {
    // console.error(e)
  }
}

/**
 * SMS 발송 기능을 호출한다.
 * @param phoneNo
 * @param body
 */
export const callSms = (phoneNo: string, body: string) => {
  location.href = 'sms:' + phoneNo + (webUtils.isIOsRequest ? '&' : '?') + 'body=' + body
}

/**
 * 전화 걸기 기능을 호출한다.
 * @param phoneNo
 */
export const callTel = (phoneNo: string) => {
  location.href = 'tel:' + phoneNo
}

/**
 * 이메일 기능을 호출한다.
 * @param phoneNo
 */
export const callEmail = (email: string) => {
  location.href = 'mailto:' + email
}
